/**
 * Created by tomers on 3/3/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("personalization-web-agent-templates/default-agent-status/defaultAgentStatusItem.tmpl");

    var RADIO_NAME = "defaultAgentStatusRadio";

    var DefaultAgentStatusEditView = {};
    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        DefaultAgentStatusEditView = Marionette.ItemView.extend({
            template: template,
            className: "status-option-container",
            ui: {
                radio: ".radio"
            },
            events: {
                "change .radio": "_onStatusRadioChange",
                "click .icon-img": "_onStatusIconClick",
                "click .icon-text": "_onStatusIconClick"
            },

            initialize: function (options) {
                this.model = options.model;
                this.isSelected = options.isSelected;
            },
            customTemplateHelpers: function() {
                return {
                    radioName: RADIO_NAME,
                    isSelected: this.isSelected
                };
            },
            _onStatusIconClick: function() {
                // note: we should use both .prop and .trigger because prop doesn't trigger the "change" event.
                // http://forum.jquery.com/topic/should-chk-prop-checked-true-trigger-change-event
                this.ui.radio.prop("checked", true).trigger("change");
            },
            _onStatusRadioChange: function() {
                this.trigger("statusRadioChange");
            }
        });
    });

    return DefaultAgentStatusEditView;

});
